// StationChartsLayout – zjednodušená mapa výběru stanice pro variantu B (veřejný internet),
// viz doc/plans/deploy-variant-b-station-charts.md. Bez filtrů, jen stanice defaultní
// zjednodušené skupiny (server GET /api/geography už omezuje podle deploy.defaultSimpleGroupTypeId,
// viz cw-server/doc/plans/deploy-config-default-simple-group.md) obarvené podle jednotlivých
// station_group (PROFI/OBS/NOOBS/OSTATNI pro referenční instanci) stejně jako „Podle skupiny“
// jinde v appce. Klik na stanici → /station-charts/:ghId.
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@heroui/react'
import { StationMap } from '../components/map/StationMap'
import { useAllStations } from '../hooks/useAppData'
import { useDefaultSimpleGroup } from '../hooks/useDefaultSimpleGroup'
import { useStationChartsMapStore } from '../store/useStationChartsMapStore'
import { UserIcon } from '../components/auth/UserIcon'
import { useTrackView } from '../hooks/useTrackProduct'

// Větší kolečka než výchozí „Podle skupiny“ mapa (tam 6/9 px) — zjednodušená mapa je určená
// pro širší veřejnost, body musí být zřetelně vidět.
const POINT_RADIUS = { normal: 8, selected: 11, normalPie: 10, selectedPie: 13 }

// Mírně výraznější popisek stanice než dnešní výchozí styl mapy (10px, #333) — na zjednodušené
// mapě bez toolbaru musí být název stanice o něco lépe čitelný, ale ne přehnaně.
const LABEL_STYLE = { font: '11px sans-serif', color: '#222', strokeWidth: 2.5 }

export function StationChartsLayout() {
  const navigate = useNavigate()
  const { allStations, isLoading } = useAllStations()
  const { colorByGhId, legend } = useDefaultSimpleGroup()
  const showLegend = useStationChartsMapStore(s => s.showLegend)
  const setShowLegend = useStationChartsMapStore(s => s.setShowLegend)

  // Sledování přístupů — vstupní mapa varianty B, vlastní část oddělená od map-select
  // (plná mapa s filtry ve StationSelectLayout), aby se nesčítaly dvě různé obrazovky.
  useTrackView('station-charts', 'station-charts-map')

  const handleStationSelect = (station) => {
    navigate(`/station-charts/${station.gh_id}`)
  }

  return (
    <div className="flex h-dvh overflow-hidden bg-gray-50">
      <div className="flex-1 relative overflow-hidden">
        <StationMap
          stations={allStations}
          selectedStation={null}
          onStationSelect={handleStationSelect}
          groupColorMode
          groupColorMap={colorByGhId}
          groupLegend={legend}
          hideTools
          pointRadius={POINT_RADIUS}
          fixedLabelMode={['name', 'qual']}
          labelStyle={LABEL_STYLE}
          defaultShowLegend={showLegend}
          onLegendVisibilityChange={setShowLegend}
        />

        {/* Domů + přihlášení — levý horní roh */}
        <div className="absolute top-2 left-2 z-10 flex items-center gap-2">
          <button
            className="flex items-center justify-center w-9 h-9 bg-white/95 shadow-md rounded-xl text-lg text-blue-600 hover:bg-blue-50 border border-gray-200 transition-colors"
            onClick={() => navigate('/')}
            title="Domů"
          >
            🏠
          </button>
          <UserIcon variant="compact" />
        </div>

        {isLoading && (
          <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2 bg-white/95 shadow-md rounded-xl px-3 py-1.5 text-xs text-gray-600 border border-gray-200">
            <Spinner size="sm" />
            Načítání stanic…
          </div>
        )}
      </div>
    </div>
  )
}
